export function gamesPracticeEnabled(settings) {
  return settings?.games?.enabled === true;
}
